import { axiosInstance } from "utils";
import { Versions } from "types";

export const getVersions = async () => {
  return await axiosInstance.get<Versions>("/versions");
};
